/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/globe_medium'
export default icon
